<!-- =========================================================================================
    File Name: DykProductEditorCard.vue
    Description: Item Component - List VIew
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>
    <vx-card id="loading-block" class="vs-con-loading__container" :collapse-action="true" title="Did You Know Products">
      <SlickList class="mb-2" lockAxis="y" :distance="5" v-model="dykProducts" @input="onProductSorted">
        <SlickItem v-for="(dykProduct, index) in dykProducts" :index="index" :key="dykProduct.id">
          <vs-alert class="p-0 mb-1" color="#EAEAEA">
            <vs-icon size="25px" color="#e5e5f9" class="float-left" style="cursor:grab;" icon="menu"></vs-icon>
            <span class="label ml-3 text-dark">{{ dykProduct.product_name }}</span>
            <vs-button class="float-right" type="line" size="small"  color="primary" icon="edit" @click="showEditDykLocalizations(dykProduct)" ></vs-button>
            <vs-button class="float-right mx-2" type="line" size="small" color="danger" icon="delete" @click="deleteDykProduct(dykProduct.product_id)" ></vs-button>
          </vs-alert>
        </SlickItem>
      </SlickList>

      <div class="vx-row">
        <div class="vx-col w-full my-2">
          <vs-button class="float-right" color="primary" type="border" icon-after icon="add" @click="showNewDykProductDialog=true">Add Product</vs-button>
        </div>
      </div>
    </vx-card>

    <add-dyk-product-dialog :showNewDykProductDialog.sync="showNewDykProductDialog" :addDykProduct="addDykProduct" :availableProducts="availableProducts"/>
    <dyk-product-localizations-card :edit-dyk-localization.sync="editDykLocalization" />
  </div>
</template>

<script>
import api from '@/http/api';
import {productHelpers} from '@/models/helpers';
import { SlickList, SlickItem } from 'vue-slicksort';
import AddDykProductDialog from "@/views/content/books/components/AddDykProductDialog";
import DykProductLocalizationsCard from "@/views/content/books/components/DykProductLocalizationsCard";

export default {
  components: {
    SlickList,
    SlickItem,
    AddDykProductDialog,
    DykProductLocalizationsCard
  },
  data() {
    return {
      showNewDykProductDialog: false,
      editDykLocalization: {
        show: false,
        product_name: '',
        localizations: []
      },
      helpers: productHelpers,
      workingRanks: [],
      highestOrderNumber: 0,
      dykProducts: [],
      availableProducts: []
    }
  },
  props: ['cyclopediaId'],
  watch: {
    cyclopediaId: function () {
      this.fetchData();
    }
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      this.showSpinnerOverCard();

      this.dykProducts = await api.getDykProducts(this.cyclopediaId);
      this.availableProducts = await api.getAvailableDykProductsToAdd(this.cyclopediaId);

      this.hideSpinnerOverCard();
    },
    async onProductSorted(sorted) {
      this.showSpinnerOverCard();

      // patch the changes (if any)
      if (sorted.length) {
        let result = await api.sortDykProducts(this.cyclopediaId, sorted);
        if(result) await this.fetchData();
      }

      this.hideSpinnerOverCard();
    },
    async addDykProduct(productId) {
      await api.addDykProducts(this.cyclopediaId, productId);
      await this.fetchData();
    },
    async deleteDykProduct(productId) {
      this.showSpinnerOverCard();

      await api.deleteDykProduct(this.cyclopediaId, productId);
      await this.fetchData();

      this.hideSpinnerOverCard();
    },
    confirmDeleteRank(rank) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        acceptText: 'DELETE',
        title: `DELETE ${rank.name}`,
        text: `Are you sure you want to delete this rank?`,
        accept: () => {
          this.deleteRank(rank);
        }
      })
    },
    showEditDykLocalizations(dykLocalProduct) {
      this.editDykLocalization = {show: true, product_name: dykLocalProduct.product_name, localizations: dykLocalProduct.localizations};
    },
    showSpinnerOverCard(){
      this.$vs.loading({
        container: '#loading-block',
        scale: 0.6
      });
    },
    hideSpinnerOverCard() {
      this.$vs.loading.close('#loading-block > .con-vs-loading')
    },
    showNotification(success, message) {
      this.$vs.notify({
        title: success ? 'Success' : 'Error',
        text: message ? message : '',
        color: success ? 'success' : 'danger',
        icon: success ? 'check_circle_outline' : 'error'});
    },
  }
}
</script>
